import { axios } from "~/plugins/axios";

const state = {};

const getters = {};

const actions = {
  async loadProjectPackages(_, projectId) {
    const resp = await axios.get(`/api/projects/${projectId}/operator-packages`);
    return resp.data;
  },

  async loadPackageCallStatistics(_, { contractId, appendixId, packageId, period }) {
    const resp = await axios.get(
      `/api/contracts/${contractId}/appendices/${appendixId}/operator-packages/${packageId}/get-call-statistics`,
      { params: { period } }
    );
    return resp.data;
  },

  async calculatePackageMargin(_, {
    contractId, appendixId, packageId, period,
    minuteCost, operatorPayroll, pmPayroll, glPayroll, administrativeExpensesPercent,
  }) {
    const resp = await axios.get(
      `/api/contracts/${contractId}/appendices/${appendixId}/operator-packages/${packageId}/get-margin`,
      {
        params: {
          period,
          minute_cost: minuteCost,
          operator_payroll: operatorPayroll,
          pm_payroll: pmPayroll,
          gl_payroll: glPayroll,
          administrative_expenses_percent: administrativeExpensesPercent,
        },
      }
    );
    return resp.data;
  },
}

const mutations = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
